import React, {useState, useRef} from 'react';
import {observer} from 'mobx-react';
import PropTypes from 'prop-types';
import Autosuggest from 'react-autosuggest';
import PopularPortOverlay from 'ferries/Home/components/FerrySearchMask/PopularPortOverlay';
import useOnClickOutside from 'helpers/hooks/useOnClickOutside';
import {
  themePort, selectAll, transformQuery, renderPortSuggestion
} from 'ferries/Home/components/FerrySearchMask/helperStore';
import {
  getResultsBasedOnTypedLanguage, isGreekText
} from 'providers/ferries/autocompleteResultsBasedOnTypedLanguage/utils';

const showSuggestions = (value) => value.trim().length > 0;

const Port = ({
  type, className: {input}, isGreekDeparture, placeholder, port, selected, popularPorts, queries,
  onChange, portString, fetchSuggestions, clearSuggestions, onSuggestionSelected, tripIndex,
  setPortByThreeLetterCode, fillWithQuery, onChangePopularPortCountry, translations
}) => {
  const [isPopularPortsOpen, setIsPopularPortsOpen] = useState(false);
  const refClickOutside = useRef(null);
  useOnClickOutside(refClickOutside, () => setIsPopularPortsOpen(false));

  const handleOpen = () => setIsPopularPortsOpen((isPopularPortsOpen) => !isPopularPortsOpen);
  const onClickPopularPort = (locationAbbr, locationName) => {
    const isGreekLocation = isGreekText(locationName);
    setPortByThreeLetterCode(type, locationAbbr, tripIndex, true, isGreekLocation);
    handleOpen();
  };
  const onClickQuery = (query) => {
    fillWithQuery(transformQuery(query));
    handleOpen();
  };
  return (
    <div ref={refClickOutside}>
      <Autosuggest
        id={`${type}-${tripIndex}`}
        theme={{...themePort, input}}
        inputProps={{
          type: 'search',
          placeholder,
          value: port,
          onClick: (event) => {
            selectAll(event);
            handleOpen(true);
          },
          onChange: (ignore, {newValue}) => onChange(type, newValue, tripIndex)
        }}
        suggestions={getResultsBasedOnTypedLanguage({term: port, listOfTerms: selected})}
        onSuggestionsFetchRequested={({value}) => fetchSuggestions(type, value, tripIndex)}
        onSuggestionsClearRequested={() => clearSuggestions(type, tripIndex)}
        getSuggestionValue={portString}
        renderSuggestion={renderPortSuggestion}
        shouldRenderSuggestions={showSuggestions}
        onSuggestionSelected={(event, {suggestion}) => onSuggestionSelected(type, suggestion, tripIndex, true)}
      />
      <div className="position-relative">
        {isPopularPortsOpen && port.length === 0 && popularPorts?.ports?.length > 0 &&
          <PopularPortOverlay
            isGreekDeparture={isGreekDeparture}
            popularPorts={popularPorts}
            queries={queries}
            onClickPopularPort={onClickPopularPort}
            onChangePopularPortCountry={onChangePopularPortCountry}
            onClickQuery={onClickQuery}
            translations={translations}
          />}
      </div>
    </div>
  );
};

Port.propTypes = {
  type: PropTypes.string.isRequired,
  className: PropTypes.shape({
    input: PropTypes.string.isRequired
  }),
  isGreekDeparture: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  selected: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
  port: PropTypes.string.isRequired,
  depFerryOwnLocationID: PropTypes.string,
  popularPorts: PropTypes.object.isRequired,
  queries: PropTypes.object,
  portString: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onSuggestionSelected: PropTypes.func.isRequired,
  fetchSuggestions: PropTypes.func.isRequired,
  clearSuggestions: PropTypes.func.isRequired,
  tripIndex: PropTypes.number,
  fillWithQuery: PropTypes.func,
  setPortByThreeLetterCode: PropTypes.func,
  onChangePopularPortCountry: PropTypes.func,
  translations: PropTypes.shape({
    recentSearches: PropTypes.string.isRequired
  })
};

export default observer(Port);
